import React, {
  useContext,
} from 'react';
import UsernavContext from '../../../../context/UsernavContext';
import { useSelector } from '../../../../../../../utils/hooks/useRedux';

interface UsernavItemExternalLinkProps {
  to: string;
  label: string;
  className?: string;
  isNotificationSelector: (store: ReduxStore) => boolean;
}
function UsernavItemExternalLink({
  to,
  label,
  className,
  isNotificationSelector = () => false,
}: UsernavItemExternalLinkProps) {
  const { closeUsernavMenu } = useContext(UsernavContext);
  const hasNotifications = useSelector(isNotificationSelector);
  function onClick() {
    closeUsernavMenu();
  }
  return (
    <a
      href={to}
      className={className}
      onClick={onClick}
    >
      {label}
      {!!hasNotifications && (
        <span className="notification-bubble" />
      )}
    </a>
  );
}

export default UsernavItemExternalLink;
